<template>
    <v-container fluid class="pa-0 d-flex align-center">
      <!-- Hour Spinners -->
    
      <v-text-field
        v-model="localTime.hours"
        type="number"
        variant="outlined"
        hide-details
        density="compact"
        style="width: 50px; text-align: center; font-size: 16px;"
        @change="validateHours"
        @wheel.prevent="scrollHours($event)"
      ></v-text-field>
   
  
      <span style="font-size: 20px; margin: 0 4px;">:</span>
  
      <!-- Minute Spinners -->
     
      <v-text-field
        v-model="formattedMinutes"
        type="number"
        variant="outlined"
        hide-details
        density="compact"
        style="width: 50px; text-align: center; font-size: 16px;"
        @change="manualMinuteChange"
        @wheel.prevent="scrollMinutes($event)"
      ></v-text-field>
     
  
      <!-- AM/PM Toggle -->
      <v-btn
        @click="toggleAMPM"
        variant="text"
        style="min-width: 50px; height: 40px; font-size: 14px; text-transform: uppercase;"
      >
        {{ localTime.ampm }}
      </v-btn>
    </v-container>
  </template>
  
  <script>
  export default {
  props: {
    modelValue: Object
  },
  data() {
    return {
      localTime: { ...this.modelValue }
    };
  },
  watch: {
    modelValue: {
      deep: true,
      handler(newVal) {
        this.localTime = { ...newVal };
      }
    },
    localTime: {
      deep: true,
      handler(newVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(this.modelValue)) {
          this.$emit('update:modelValue', { ...newVal });
        }
      }
    }
  },
  computed: {
    formattedMinutes: {
      get() {
        return this.localTime.minutes.toString().padStart(2, "0");
      },
      set(value) {
        this.localTime.minutes = parseInt(value) || 0;
      },
    },
  },
  methods: {
    toggleAMPM() {
      this.localTime.ampm = this.localTime.ampm === "AM" ? "PM" : "AM";
    },
    validateHours() {
      this.localTime.hours = ((this.localTime.hours - 1 + 12) % 12) + 1;
    },
    manualMinuteChange() {
      if (this.localTime.minutes < 0) this.localTime.minutes = 59;
      if (this.localTime.minutes > 59) this.localTime.minutes = 0;
    },
    incrementHours() {
      this.localTime.hours = this.localTime.hours === 12 ? 1 : this.localTime.hours + 1;
    },
    decrementHours() {
      this.localTime.hours = this.localTime.hours === 1 ? 12 : this.localTime.hours - 1;
    },
    incrementMinutes() {
      this.localTime.minutes = this.localTime.minutes === 59 ? 0 : this.localTime.minutes + 1;
    },
    decrementMinutes() {
      this.localTime.minutes = this.localTime.minutes === 0 ? 59 : this.localTime.minutes - 1;
    },
    scrollHours(event) {
      if (document.activeElement !== event.target) return;
      event.deltaY < 0 ? this.incrementHours() : this.decrementHours();
    },
    scrollMinutes(event) {
      if (document.activeElement !== event.target) return;
      event.deltaY < 0 ? this.incrementMinutes() : this.decrementMinutes();
    }
  }
};
  </script>